
import { api } from "@/api";

const actions = {
  async setPatientData({ commit }, payload) {
    try {
      const { data } = await api.patients.get(payload);
      commit("SET_PATIENT_DATA", data);
    } catch (error) {
      console.error(error);
    }
  },
  setPatientRef({ commit }, payload) {
    commit("SET_PATIENT_REF", payload);
  },
  setUserData({ commit }, payload) {
    commit("SET_USER_DATA", payload);
  },
};

export default actions;
